(() => {
  if (customElements.get('nobl-tolstoy-carousel')) return;
  const GAP = 20;
  const ICON = {
    arrow: 'M7.797 16.664.648 9.204A1.071 1.071 0 0 1 .375 8.5c0-.195.078-.43.234-.625L7.758.415a.932.932 0 0 1 1.328-.04c.39.352.39.938.039 1.328L2.602 8.5l6.562 6.875a.932.932 0 0 1-.039 1.328.932.932 0 0 1-1.328-.039Z',
    expand: 'M.047.352A.663.663 0 0 0 0 .562v3.375c0 .329.258.563.563.563a.542.542 0 0 0 .562-.563V1.922l3.164 3.164c.234.234.586.234.797 0 .234-.211.234-.563 0-.797L1.922 1.125h2.016A.542.542 0 0 0 4.5.562.555.555 0 0 0 3.937 0H.563a.657.657 0 0 0-.211.047.641.641 0 0 0-.305.305Zm11.93 11.32c.023-.07.023-.14.023-.235v-3.35c0-.328-.234-.586-.563-.586a.57.57 0 0 0-.562.563v2.039L7.711 6.937a.513.513 0 0 0-.774 0 .513.513 0 0 0 0 .774l3.165 3.164h-2.04a.57.57 0 0 0-.562.563c0 .328.258.562.563.562h3.374c.094 0 .165 0 .235-.023a.763.763 0 0 0 .305-.305Z',
    muted: 'M6.266 1.551a0.667 0.667 0 0 1 0.382 0.583v7.714c0 0.261 -0.161 0.482 -0.381 0.602a0.651 0.651 0 0 1 -0.703 -0.12L2.85 7.918h-1.346a1.269 1.269 0 0 1 -1.286 -1.286v-1.286c0 -0.703 0.562 -1.286 1.286 -1.286h1.346L5.563 1.671a0.651 0.651 0 0 1 0.703 -0.12Zm2.492 2.651 1.105 1.106 1.105 -1.106c0.18 -0.18 0.483 -0.18 0.663 0 0.201 0.201 0.201 0.502 0 0.683L10.526 5.991l1.106 1.104c0.201 0.201 0.201 0.502 0 0.683a0.44 0.44 0 0 1 -0.663 0l-1.106 -1.105 -1.104 1.106c-0.201 0.201 -0.502 0.201 -0.683 0 -0.201 -0.182 -0.201 -0.483 0 -0.684l1.105 -1.105L8.073 4.886c-0.2 -0.18 -0.2 -0.482 0 -0.683 0.182 -0.18 0.483 -0.18 0.684 0Z',
    sound: 'M6.627 1.55c.238.101.411.342.411.583v7.714c0 .261-.173.482-.411.603a.742.742 0 0 1-.757-.121l-2.921-2.41H1.5c-.779 0-1.385-.563-1.385-1.286V5.347c0-.703.606-1.286 1.385-1.286h1.449l2.921-2.39a.742.742 0 0 1 .757-.121Zm3.721 1.447c.931.723 1.537 1.788 1.537 2.993 0 1.225-.606 2.29-1.537 2.993a.542.542 0 0 1-.735-.06c-.195-.201-.152-.502.065-.683.714-.522 1.168-1.326 1.168-2.25 0-.904-.454-1.708-1.168-2.23a.475.475 0 0 1-.065-.683.565.565 0 0 1 .735-.08ZM9.029 4.503c.476.362.779.884.779 1.487 0 .623-.303 1.145-.779 1.507a.55.55 0 0 1-.736-.081.454.454 0 0 1 .087-.663.966.966 0 0 0 .389-.763.928.928 0 0 0-.389-.743.475.475 0 0 1-.087-.683.57.57 0 0 1 .736-.061Z'
  };
  const svg = (w, h, box, path, fill, style) => `<svg width="${w}" height="${h}" viewBox="${box}" fill="${fill}" aria-hidden="true"${style ? ` style="${style}"` : ''}><path d="${path}"${fill === 'none' ? ' fill="#090A0B"' : ''}></path></svg>`;
  const corner = 'position: absolute; width: 28px; height: 28px; padding: 8px; border: 0px; border-radius: 20px; background: rgba(0, 0, 0, 0.3); backdrop-filter: blur(2px); color: white;';

  class NoblTolstoyCarousel extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.carousel-track');
      this.cards = [...this.querySelectorAll('.carousel-card')];
      this.aligns = [...this.querySelectorAll('.carousel-arrow-align')];
      this.player = document.querySelector(this.dataset.player)?.querySelector('nobl-video-gallery');
      this.muted = false; this.playing = null; this.paused = false; this.wasPaused = false;
      this.cards.forEach((card, index) => {
        const video = card.querySelector('video');
        video.addEventListener('ended', () => { if (this.playing === index && !this.paused) this.advance(); });
      });
      ['pointerenter', 'pointerdown', 'focusin', 'touchstart'].forEach(name => this.track.addEventListener(name, event => {
        const card = event.target.closest?.('.carousel-card');
        if (card) this.warm(this.cards.indexOf(card));
      }, {passive: true, capture: name === 'pointerenter'}));
      this.addEventListener('click', event => {
        const arrow = event.target.closest('.carousel-arrow');
        if (arrow) { this.scroll(arrow.dataset.dir === 'right' ? 1 : -1); return; }
        const card = event.target.closest('.carousel-card');
        if (!card) return;
        const index = this.cards.indexOf(card);
        const action = event.target.closest('[data-action]')?.dataset.action;
        if (action === 'expand') { this.expand(index); return; }
        if (action === 'mute') { this.muted = !this.muted; this.render(); return; }
        this.toggle(index);
      });
      this.layout = this.layout.bind(this);
      if ('ResizeObserver' in window) new ResizeObserver(this.layout).observe(this.track);
      window.addEventListener('resize', this.layout);
      this.layout();
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting === this.visible) return;
          this.visible = entry.isIntersecting; this.playing = null; this.paused = false; this.render();
        }), {threshold: 0.1}).observe(this);
        const primer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          primer.disconnect();
          this.cards.slice(0, (this.perView || 2) + 1).forEach(card => {
            const video = card.querySelector('video');
            if (video.getAttribute('src')) return;
            video.preload = 'metadata';
            video.src = video.dataset.src;
          });
        }, {rootMargin: '400px 0px'});
        primer.observe(this);
      }
    }
    layout() {
      const count = this.cards.length, width = this.track.clientWidth;
      if (!count || !width) return;
      const small = width <= 450;
      const fit = Math.floor((width + GAP) / (416 * 9 / 16 + GAP));
      this.perView = small && fit < count ? 2 : 5;
      this.cardWidth = Math.max(80, (width + GAP) / (this.perView + (small && count >= 2 ? 0.4 : 0)) - GAP);
      const height = Math.min(800, this.cardWidth * 16 / 9);
      this.track.style.gap = GAP + 'px';
      this.track.style.gridTemplateColumns = `repeat(${count}, ${this.cardWidth}px)`;
      this.track.style.justifyContent = count > this.perView ? 'start' : 'center';
      this.cards.forEach(card => {
        card.style.width = this.cardWidth + 'px'; card.style.height = height + 'px';
        card.querySelector('[data-action="toggle"]').style.height = height + 'px';
        const play = card.querySelector('.carousel-play'); if (play) play.style.top = height / 2 + 'px';
      });
      const arrows = window.innerWidth > 450 && count > this.perView;
      this.aligns.forEach((align, i) => {
        const has = !!align.firstElementChild;
        if (arrows && !has) {
          const dir = i ? 'right' : 'left';
          align.innerHTML = `<button type="button" class="carousel-arrow" data-dir="${dir}" aria-label="${this.dataset[dir === 'right' ? 'labelRight' : 'labelLeft']}">${svg(10, 18, '0 0 10 18', ICON.arrow, 'none', dir === 'right' ? 'transform: rotate(180deg);' : '')}</button>`;
        } else if (!arrows && has) align.innerHTML = '';
      });
      if (this.track.clientWidth !== width && !this.relayout) { this.relayout = true; this.layout(); this.relayout = false; }
    }
    scroll(direction) {
      const max = Math.max(0, this.cards.length - this.perView), step = this.cardWidth + GAP;
      const index = Math.min(max, Math.round(this.track.scrollLeft / step)) + direction;
      this.track.scrollTo({left: (index < 0 ? max : index > max ? 0 : index) * step, behavior: 'smooth'});
    }
    toggle(index) {
      if (this.playing === index) this.paused = !this.paused;
      else { this.playing = index; this.paused = false; }
      this.render();
    }
    advance() {
      if (this.playing === null) return;
      this.playing = (this.playing + 1) % this.cards.length; this.paused = false; this.restart = true;
      this.render();
    }
    expand(index) {
      this.playing = null; this.paused = false; this.render();
      if (!this.player?.open) return;
      this.player.opener = this.cards[index].querySelector('[data-action="toggle"]');
      this.player.open(index);
    }
    render() {
      const resuming = this.wasPaused && !this.paused; this.wasPaused = this.paused;
      this.cards.forEach((card, index) => {
        const video = card.querySelector('video'), active = index === this.playing && !this.paused;
        const label = card.dataset.label;
        let play = card.querySelector('.carousel-play'), extras = card.querySelectorAll('[data-extra]');
        if (active) {
          play?.remove();
          if (!extras.length) {
            card.insertAdjacentHTML('beforeend', `<button data-extra data-action="expand" aria-label="${this.dataset.labelExpand} ${label}" style="${corner} top: 6px; right: 6px;">${svg(12, 12, '0 0 12 12', ICON.expand, 'currentColor')}</button><button type="button" data-extra data-action="mute" style="${corner} right: 6px; bottom: 6px;"></button>`);
          }
          const mute = card.querySelector('[data-action="mute"]');
          mute.setAttribute('aria-label', this.muted ? this.dataset.labelUnmute : this.dataset.labelMute);
          mute.innerHTML = svg(12, 12, '0 0 12 12', this.muted ? ICON.muted : ICON.sound, 'currentColor');
          video.muted = this.muted;
          const start = () => video.play().catch(() => { this.muted = true; video.muted = true; this.render(); video.play().catch(() => {}); });
          if (!video.getAttribute('src')) {
            this.warm(index);
            start();
          } else if (video.paused) {
            if (!resuming || this.restart) video.currentTime = 0;
            start();
          }
        } else {
          video.pause();
          extras.forEach(el => el.remove());
          if (!play && !(index === this.playing && !this.paused)) {
            const height = parseFloat(card.style.height) || card.offsetHeight;
            card.insertAdjacentHTML('beforeend', `<button type="button" data-action="toggle-play" class="carousel-play absolute z-10 flex items-center justify-center rounded-full p-0 focus-visible:ring-4 focus-visible:ring-white/60" aria-label="${this.dataset.labelPlay} ${label}" style="width: 64px; height: 64px; left: 50%; top: ${height / 2}px; transform: translate(-50%, -50%); background: rgb(0, 0, 0); border: 0px solid transparent; color: rgb(255, 255, 255); opacity: 1;">${svg(24, 24, '0 0 24 24', 'M4 3.532c0-1.554 1.696-2.514 3.029-1.715l14.113 8.468c1.294.777 1.294 2.653 0 3.43L7.029 22.183c-1.333.8-3.029-.16-3.029-1.715V3.532Z', 'currentColor')}</button>`);
          }
        }
      });
      this.restart = false;
      if (this.playing !== null) this.warm(this.playing + 1);
    }
    warm(index) {
      const card = this.cards[(index + this.cards.length) % this.cards.length];
      const video = card?.querySelector('video');
      if (!video) return;
      video.preload = 'auto';
      if (!video.getAttribute('src')) video.src = video.dataset.src;
    }
  }
  customElements.define('nobl-tolstoy-carousel', NoblTolstoyCarousel);
})();
